var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2104(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 26,
    viewBox: "0 0 15 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.730469 1V25H14.3476V5.6L0.730469 1Z",
    stroke: "#009FE3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_285_5198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5708,
    y: 6.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5708,
    y: 6.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5,
    stroke: "#009FE3",
    strokeWidth: 1.6,
    mask: "url(#path-2-inside-1_285_5198)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_285_5198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5708,
    y: 12.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5708,
    y: 12.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5,
    stroke: "#009FE3",
    strokeWidth: 1.6,
    mask: "url(#path-3-inside-2_285_5198)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_285_5198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5708,
    y: 18.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5708,
    y: 18.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5,
    stroke: "#009FE3",
    strokeWidth: 1.6,
    mask: "url(#path-4-inside-3_285_5198)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-4_285_5198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.45898,
    y: 6.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.45898,
    y: 6.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5,
    stroke: "#009FE3",
    strokeWidth: 1.6,
    mask: "url(#path-5-inside-4_285_5198)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-5_285_5198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.45898,
    y: 12.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.45898,
    y: 12.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5,
    stroke: "#009FE3",
    strokeWidth: 1.6,
    mask: "url(#path-6-inside-5_285_5198)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-6_285_5198",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.45898,
    y: 18.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.45898,
    y: 18.625,
    width: 4.04833,
    height: 4.5,
    rx: 0.5,
    stroke: "#009FE3",
    strokeWidth: 1.6,
    mask: "url(#path-7-inside-6_285_5198)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2104);
export default __webpack_public_path__ + "static/media/Group-2104.f53ce17440247c0bd9578575d0353555.svg";
export { ForwardRef as ReactComponent };